import React, { Component } from 'react';
import { DetailsList, DetailsListLayoutMode, TextField, mergeStyleSets, CommandBar, Panel, PanelType, Selection, SelectionMode, IColumn, IconButton } from 'office-ui-fabric-react';
import { MyContext } from '../../context';
import ProfileRuleSettings from './ProfileRuleSettings';
import { getProfileRule } from '../../queries/querySettings'; 


const classNames = mergeStyleSets({
    container: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        padding: '0',
    },
    detailsList: {
        flexGrow: 1,
        overflowX: 'auto',
    },
    commandBar: {
        width: '100%',
    },
});
export interface IDocument {
    name: String;
    text: String;
    rules: String;

}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}
class ProfileRules extends Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];
    constructor(props) {
        super(props);
        this._allItems = _generateDocuments(this.props.profileRulesData);
        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        let columns: IColumn[] = [

            {
                key: 'column1',
                name: <MyContext.Consumer>{context => context.getTranslation("configuration", "name")}</MyContext.Consumer>,
                fieldName: 'name',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onColumnClick: this._onColumnClick,
            },
            { key: 'column2', name: <MyContext.Consumer>{context => context.getTranslation("configuration", "description")}</MyContext.Consumer>, fieldName: 'text', minWidth: 100, maxWidth: 200, isResizable: true },
            
            {
                key: 'settings',
                name: '',
                fieldName: 'settings',
                minWidth: 40,
                maxWidth: 40,
                isResizable: false,
                onRender: (item) => (
                    <IconButton
                        iconProps={{ iconName: 'Settings', styles: { root: { fontSize: 12 } } }}
                        title="Edit"
                        ariaLabel="Edit"
                        onClick={() => this.openPanel('Edit Profile Rule', false)}
                    />
                ),
            }
        ]
        this.state = {
            
            searchText: '',
            isPanelOpen: false,
            panelTitle: '',
            isNew: false,
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: true,
            count: 0,
            showModal: false,
            showModalMapping: false,
            profileRulesItems: this._allItems,
            sortedColumnKey: 'name',
            isSortedDescending: false,
            profileRuleData: null
        };
    }

  

    componentDidUpdate(prevProps) {
        if (prevProps.profileRulesData !== this.props.profileRulesData) {
            const updatedItems = _generateDocuments(this.props.profileRulesData);
            this._selection.setItems(updatedItems, true); // true = clear selection to update
            this.setState({ 
                profileRulesItems: updatedItems,
            });
        }
    }
    _onColumnClick = (ev, column) => {
        const { profileRulesItems, isSortedDescending, sortedColumnKey } = this.state;
        const newIsSortedDescending = sortedColumnKey === column.fieldName ? !isSortedDescending : false;
        const sortedItems = _copyAndSort(profileRulesItems, column.fieldName, newIsSortedDescending);

        this.setState({
            profileRulesItems: sortedItems,
            sortedColumnKey: column.fieldName,
            isSortedDescending: newIsSortedDescending,
        });
    };


    _getSelectionDetails(): string {


        const selectedItems = this._selection.getSelection();

        if (selectedItems.length > 0) {

            return selectedItems[0];
        }
        return '';
    }

    onSelectionChanged = () => {
        this.forceUpdate();
    };
    onSearchChange = (event, newValue) => {
        this.setState({ searchText: newValue });
    };

    openPanel = async (title, isNew) => {
        if (!isNew && this._selection.getSelectedCount() === 1) {
            const selectedItem = this._selection.getSelection()[0];
            const selectedRuleId = selectedItem.id;
            var profileRuleData = null;

            // Fetch the profile rule data
            try {
                const { apol, authorization } = this.props; // Apollo client and auth from props/context
                const { data } = await apol.query({
                    query: getProfileRule,
                    variables: {
                        auth: authorization,
                        id: selectedRuleId,
                    },
                });
                profileRuleData = data.getProfileRule;
            } catch (error) {
                console.log('Error fetching profile rule:', error);
            }

            this.setState({ isPanelOpen: true, panelTitle: title, isNew, profileRuleData: profileRuleData });

        } else {
            this.setState({ isPanelOpen: true, panelTitle: title, isNew, profileRuleData: null });
        }
    };

    closePanel = () => {
        this.setState({ isPanelOpen: false, panelTitle: '' });
    };

    render() {
        const { profileRulesItems, columns, searchText, isPanelOpen, panelTitle, isCompactMode, sortedColumnKey, isSortedDescending } = this.state;
        const sortedColumns = columns.map(col => ({
            ...col,
            isSorted: col.fieldName === sortedColumnKey,
            isSortedDescending: col.fieldName === sortedColumnKey ? isSortedDescending : false,
        }));
        const filteredItems = profileRulesItems.filter(item =>
            item.name.toLowerCase().includes(searchText.toLowerCase()) ||
            item.text.toLowerCase().includes(searchText.toLowerCase()) 
        );

        const commandBarItems = [
            {
                key: 'createProfileRule',
                text: <MyContext.Consumer>{context => context.getTranslation("configuration", "createProfileRule")}</MyContext.Consumer>,
                iconProps: { iconName: 'Add' },
                onClick: () => this.openPanel('Create Profile Rule', true),
                disabled: !this.props.accessProfiles,
            },
            {
                key: 'edit',
                text: <MyContext.Consumer>{context => context.getTranslation("configuration", "edit")}</MyContext.Consumer>,
                iconProps: { iconName: 'Edit' },
                onClick: () => this.openPanel('Edit Profile Rule', false),
                disabled: this._selection.getSelectedCount() !== 1,

            },
        ];

        const farItems = [
            {
                key: 'search',
                onRender: () => (
                    <TextField
                        placeholder="Search"
                        onChange={this.onSearchChange}
                        styles={{ root: { marginRight: 10, alignSelf: 'center' } }}
                    />
                ),
            },
        ];

        return (
            <MyContext.Consumer>
                {context => (
                    <div className={classNames.container}>
                        <div className={classNames.header}>
                            <CommandBar items={commandBarItems} farItems={farItems} className={classNames.commandBar} />
                        </div>
                        <DetailsList
                            items={filteredItems}
                            columns={sortedColumns}
                            setKey="set"
                            selection={this._selection}
                            layoutMode={DetailsListLayoutMode.justified}
                            selectionPreservedOnEmptyClick={true}
                            ariaLabelForSelectionColumn="Toggle selection"
                            checkButtonAriaLabel="select row"
                            styles={{ root: classNames.detailsList }}
                            isCompactMode={isCompactMode}

                        />
                        <Panel
                            isOpen={isPanelOpen}
                            onDismiss={this.closePanel}
                            type={PanelType.medium}
                            headerText={panelTitle}
                            closeButtonAriaLabel="Close"
                        >
                            <ProfileRuleSettings profilesRuleList={filteredItems} title={panelTitle} profileRuleData={this.state.isNew ? [] : this.state.profileRuleData} closePanel={this.closePanel} apol={this.props.apol} accessProfiles={this.props.accessProfiles} authorization={this.props.authorization} userRules={this.props.userRules} tenantData={this.props.tenantData} />
                        </Panel>
                    </div>
                )}
            </MyContext.Consumer>
        );
    }
}


function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const key = columnKey;
    return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

function _generateDocuments(DataArr) {
    const items = [];
    if (DataArr !== undefined && DataArr != null || DataArr !== "null") {
        for (let i = 0; i < DataArr.length; i++) {

            items.push(DataArr[i]);
        }
    }
    return items;
}


export default ProfileRules;